import { render, staticRenderFns } from "./PFCustomerDocuments.vue?vue&type=template&id=c5ddf2ba"
import script from "./PFCustomerDocuments.vue?vue&type=script&lang=js"
export * from "./PFCustomerDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports